import {sample} from 'effector';

import {RestError, showRestError} from 'core/errors';

import {fetchDataFx, commonData$, DocumentsDetailGate} from './index';

const currentDocumentResponse = sample({
    clock: fetchDataFx.done,
    source: DocumentsDetailGate.state,
    fn: ({id}, {params, result}) => (id === params ? result : null),
});

commonData$
    .on(currentDocumentResponse, (state, result) => result ?? state)
    .reset(DocumentsDetailGate.close);

fetchDataFx.fail.watch(({error}) => showRestError(error as RestError));

sample({
    clock: DocumentsDetailGate.open,
    fn: ({id}) => id,
    target: fetchDataFx,
});
